import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageunique',
  pure: false,
  standalone: true
})
export class MessageuniquePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value !== undefined && value !== null) {
      return Array.from(new Set(value.map((item: any) => item.messageId)))
        .map(id => value.find((item: any) => item.messageId === id));
    }
    return value;
  }

}
